'use strict';

const _ = require('underscore');
const SVGNodeView = require('common/ui/view/svg/node');
const SVGIconView = require('common/ui/view/svg/icon');
const SVGCollectionView = require('common/ui/view/svg/collection');
const ActionSettingView = require('process/ui/view/action/setting');
const ModalView = require('common/ui/view/modal/index');
const ImageHelper = require('common/ui/template/helper/image');
const ActionContext = require('process/domain/value/context');
const ProcessPermission = require('process/domain/entity/permission');
const i18n = require('i18next');

const ActionIconView = SVGNodeView.extend({
    className: 'action-icon',
    shapeViewClass: 'circle',
    shapeViewOptions: {r: 10},

    locator: function() {
        return {
            x: 10,
            y: 0
        }
    }
});

const ActionView = SVGNodeView.extend({
    className: 'action',
    shapeViewClass: 'circle',
    shapeViewOptions: {r: 0},

    locator: function() {
        const yLocator = this.getOption('yLocator');

        return {
            x: 0,
            y: yLocator(this.model)
        }
    },

    onRender: function() {
        _.bindAll(this, 'edit');

        ActionView.__super__.onRender.call(this);

        this.renderBackground();
        this.renderClipPath();

        const context = this.getOption('context');
        const actionContext = ActionContext.build(context, this.model);
        if(context.getProjectRole().getPermission(
            ProcessPermission.ActionEditPermission
        ).isPermitted(actionContext)) {
            this.renderEditButton();
        }

        this.renderActionIcon();
        this.renderName();
        if(this.model.isDelayed()) {
            this.renderWarning();
        }
        this.renderState();
    },

    renderBackground: function() {
        this.$el.append('rect')
            .classed('action-background', true)
            .attr('width', 286)
            .attr('height', 36)
            .attr('x', 0)
            .attr('y', -18);
    },

    renderClipPath: function() {
        const clipPath = this.$el.append('clipPath')
            .attr('id', 'clip');

        clipPath.append('rect')
            .attr('width', 180)
            .attr('height', 36)
            .attr('x', 0)
            .attr('y', -18)
            .attr('pointer-events', 'none');
    },

    renderActionIcon: function() {
        const iconView = new ActionIconView({
            model: this.model
        });
        const assignees = this.getSortedAssignees();
        let imageURL;
        if(assignees.length > 0) {
            imageURL = assignees[0].getImageURL();
        }

        this.$el
            .append(iconView.render().el)
            .append(iconView.renderImage(ImageHelper(imageURL, 'small')));
    },

    renderWarning: function() {
        const iconView = new SVGIconView({
            className: 'action-warning-icon',
            class: 'fa fa-fire',
            offset: {x: 16, y: -6},
            size: 12,
            fontSize: 8
        });

        this.$el
            .append(iconView.render().el)
            .append('text')
            .text(i18n.t('process:action-list.warning.action-delayed'))
            .style('font-size', 10)
            .style('fill', '#EF5350')
            .attr('x', 24)
            .attr('y', 17);
    },

    renderName: function() {
        this.$el
            .append('a')
            .attr('xlink:href', this.model.path())
            .classed('push-state', true)
            .append('text')
            .text(this.model.getName())
            .style('font-size', 14)
            .attr('x', 24)
            .attr('y', 5)
            .attr('clip-path', 'url(#clip)');
    },

    renderEditButton: function() {
        this.$el
            .append('a')
            .classed('btn btn-primary btn-sm gantt-action-edit', true)
            .append('text')
            .text(i18n.t('module/word:edit'))
            .style('font-size', 12)
            .attr('x', 252)
            .attr('y', 4)
            .on('click', this.edit);

        this.$el
            .append('rect')
            .classed('gantt-action-edit-background', true)
            .attr('width', 44)
            .attr('height', 24)
            .attr('x', 242)
            .attr('y', -13)
            .attr('rx', 4)
            .attr('ry', 4)
            .on('click', this.edit);
    },

    renderState: function() {
        const state = this.model.getCurrentState();

        this.$el
            .append('text')
            .text(state.getName())
            .style('font-size', 10)
            .style('fill', state.get('color'))
            .attr('x', 188)
            .attr('y', 4)
            .attr('pointer-events', 'none');
    },

    edit: function() {
        const modal = new ModalView({
            model: this.model,
            title: i18n.t('process:action-setting.update'),
            bodyView: new ActionSettingView({
                context: this.getOption('context'),
                model: this.model,
                project: this.model.getProject(),
            }),
            large: true,
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    },

    // 担当者に自分が入っている時は先頭にする
    getSortedAssignees: function() {
        const user = this.getOption('context').getUser();
        let assignees = this.model.getAssignees();

        if(assignees.length > 0) {
            const index = _.findIndex(assignees, assignee => {
                return assignee.id == user.id;
            });
            if(index !== -1) {
                const assignedUser = assignees.splice(index, 1);
                assignees.unshift(assignedUser[0]);
            }
        }

        return assignees;
    }
});

module.exports = SVGCollectionView.extend({
    className: 'action-list',
    childView: ActionView,
    childViewOptions: function() {
        return {
            context: this.getOption('context')
        };
    },
    collectionEvents: {
        'add change remove': 'render'
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/gantt/action-list.js